export const ADMIN_TABLE_DEFAULT_PAGE_SIZE = 10;
export const ADMIN_TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50, 100];
